import { createContext, useContext, useEffect, useState } from "react"
import {jwtDecode} from "jwt-decode"

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (token) {
      try {
        const decoded = jwtDecode(token)
        setUser({
          email: decoded.email,
          name: decoded.name,
          role: decoded.role,
        })
      } catch (err) {
        console.error("Invalid token", err)
        localStorage.removeItem("token")
      }
    }
    setLoading(false)
  }, [])

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
